import {direct_child, element_closest, node_each, set_class} from 'lib/utilities/dom';
import watch from 'lib/object/watch';
import {function_delay} from 'lib/utilities/time';

export default function init_navbar() {
    init_burger_menu();
    init_dropdowns();
}

function init_dropdowns() {
    const dropdowns = document.querySelectorAll('.navbar .menu-item-has-children');
    const activeDropdown = document.querySelector('.navbar .dropdown-item.active');

    if (activeDropdown) {
        const parent = element_closest(activeDropdown, '.menu-item-has-children');
        const navLink = direct_child(parent, '.nav-link');

        parent?.classList.add('active');
        navLink?.classList.add('active');
    }

    node_each(dropdowns, (dropdown) => {
        const openNav = function_delay(250, () => {
            dropdown.classList.add('is-active');
        });
        const closeNav = function_delay(250, () => {
            dropdown.classList.remove('is-active');
        });
        const state = {
            isMouseOver: false,
            isClicked: false,
            isUsingTouch: App.detectTouchDevice.isUsingTouch()
        };

        const touchTrigger = dropdown.querySelector('.nav-link');

        dropdown?.addEventListener('mouseenter', () => state.isMouseOver = true);
        dropdown?.addEventListener('mouseleave', () => state.isMouseOver = false);
        touchTrigger?.addEventListener('click', () => state.isClicked = ! state.isClicked);
        document.body.addEventListener('click', (event) => {
            if (! element_closest(event.target as Element, '.menu-item-has-children')) {
                state.isClicked = false;
            }
        })

        App.detectTouchDevice.on('change', (isUsingTouch) => {
            if (! isUsingTouch) {
                state.isClicked = false;
            }

            state.isUsingTouch = isUsingTouch;
        });

        watch.all(state, () => {
            if (state.isUsingTouch) {
                set_class(dropdown, 'is-active', state.isClicked);
            } else {
                if (state.isMouseOver) {
                    closeNav.clear();
                    openNav();
                } else {
                    openNav.clear();
                    closeNav();
                }
            }
        });
    });
}

function init_burger_menu() {
    const toggler = document.querySelector<HTMLElement>('.navbar .navbar-toggler');

    if (toggler) {
        document.body.addEventListener('click', event => {
            if (! element_closest(event.target as Element, '.navbar') && ! toggler.classList.contains('collapsed')) {
                toggler.click();
            }
        });
    }
}